const UserPages = {
  settings: 'settings',
  wallet: 'wallet',
  loyalty: 'loyalty',
  referrals: 'referrals',
  orders: 'orders'
};

export default UserPages;
